import { CardTypeEnum } from '@colonist/game-states';
import { ArrayUtils } from '@colonist/utils';
export class UIGameCardViewInventory {
    static getPartitionCardIndexes(cardsData) {
        const cardTypeWhichShouldCreateAPartition = [
            CardTypeEnum.AnyResource,
            CardTypeEnum.Development
        ];
        const cardTypeArray = cardsData.map((cardData)=>cardData.cardTypeEnum);
        const partitionIndexes = new Set();
        for (const cardType of cardTypeWhichShouldCreateAPartition){
            const index = ArrayUtils.findIndexGreaterThanOrEqual(cardTypeArray, cardType);
            if (index == -1) continue;
            partitionIndexes.add(index);
        }
        partitionIndexes.delete(0);
        return Array.from(partitionIndexes);
    }
}
